import * as React from 'react';
import styled from 'styled-components';
import { COLORS } from '../../tokens/colors';
import { rem } from '../../tokens/spacing';

const StyledCard = styled.div`
  width: 100%;
  padding: ${rem(10)} ${rem(12)};
  background-color: ${COLORS.TagShadow};
  border-radius: ${rem(6)};
  box-sizing: border-box;
`;

export interface CriteriaRuleCardProps {
  semanticId?: string;
  children: React.ReactNode;
}

export function CriteriaRuleCard({ semanticId, children }: CriteriaRuleCardProps) {
  return <StyledCard data-semantic-id={semanticId}>{children}</StyledCard>;
}

CriteriaRuleCard.displayName = 'CriteriaRuleCard';
